export const getTagCloudWidgetData = (state) => state.tagCloudWidget;
